import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Sentry from '@sentry/react'

import { selectToken, setToken } from './authenticationSlice'
import useStorage from 'containers/useStorage'

import api from '../api'

const useToken = () => {
  const [isLoadingToken, setIsLoadingToken] = useState(true)
  const token = useSelector(selectToken)
  const storage = useStorage()

  const dispatch = useDispatch()

  const refreshToken = async () => {
    try {
      const response = await api.post('/auth/refresh_token')
      const data = response.data

      dispatch(
        setToken({
          accessToken: data.access_token,
          accessTokenExpiresAt: data.access_token_expires_at,
          userId: data.user_id,
        })
      )

      // Check if there's a stored URL to redirect to (from OAuth provider connection flow)
      // Only redirect if not on sign-in page (to avoid redirect loop)
      // Allow redirects from OAuth callbacks (/microsoft/redirect, /merge-account, etc.)
      const returnUrl = storage.getUrlWhenLoggedIn()
      const isOnSignInPage = window.location.pathname === '/sign-in'
      if (returnUrl && !isOnSignInPage) {
        storage.removeUrlWhenLoggedIn()
        // Use setTimeout to ensure state is updated before redirect
        setTimeout(() => {
          window.location.href = returnUrl
        }, 100)
      }
    } catch (error) {
      Sentry.captureException(error)
    }
    setIsLoadingToken(false)
  }

  useEffect(() => {
    refreshToken()

    setInterval(() => refreshToken(), 300000)

    return () => {
      clearInterval()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { isLoadingToken, refreshToken }
}

export default useToken
